import type { ExtensionHandler } from '@atlaskit/editor-common/extensions';

import type { InlineExternalImageParams } from '@confluence/inline-external-image';

import type { InlineImageParams } from '../extensionHandlerTypes';

type ExtensionParamsType = InlineExternalImageParams | InlineImageParams;

export const getTemplateMigrationExtHandler =
	(): ExtensionHandler<ExtensionParamsType> => (extension) => {
		if (!extension) {
			return null;
		}
		// Add template migration extension handlers logic here

		return null;
	};
